import React, { useRef, useState } from 'react';
import './DateInput.scss';
import Calender from '../../../assets/icons/calendar.svg';
import { GreenCheckBox } from '../../../components/greenCheckboxes/greenCheckBox';

interface IDateInput {
  title: string;
  hasDisabled?: boolean;
  placeHolder?: string;
}

const dateInput = ({ title, hasDisabled = false, placeHolder }: IDateInput) => {
  const [date, setDate] = useState<string>(placeHolder ? placeHolder : '');
  const [disabled, setDisabled] = useState<boolean>(false);

  const calendarRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (calendarRef.current && !disabled) {
      calendarRef.current?.showPicker();
    }
  };

  const setDisabledInput = (value: boolean) => {
    setDate('');
    setDisabled(value);
  };

  return (
    <div className="scheduleModificationDateInputComponent">
      <div className="titleText">{title}</div>
      {hasDisabled ? (
        <div className="disabledDateInputContainer">
          <div className={`dateInput ${disabled ? '' : 'hidden'}`}>
            <div className="dateTexts">{date}</div>
            <input
              ref={calendarRef}
              type="date"
              style={{ visibility: 'hidden', width: 0 }}
              onChange={(e) => {
                setDate(String(e.target.value).replace('-', '.').replace('-', '.'));
              }}
            />
            <img src={Calender} alt="" className="calenderImage" onClick={handleButtonClick} />
          </div>
          <div className="disableButtonContainer">
            <GreenCheckBox
              onCheck={() => {
                setDisabledInput(!disabled);
              }}
              defaultValue={disabled}
              text={'미정'}
            />
          </div>
        </div>
      ) : (
        <div className="dateInputContainerTwo">
          <div className="dateTexts" style={{ width: '500px' }}>
            {date}
          </div>
          <input
            ref={calendarRef}
            type="date"
            className="inputElement"
            style={{ visibility: 'hidden' }}
            onChange={(e) => {
              setDate(String(e.target.value).replace('-', '.').replace('-', '.'));
            }}
          />
          <img src={Calender} alt="" className="calenderImageTwo" onClick={handleButtonClick} />
        </div>
      )}
    </div>
  );
};

export default dateInput;
